export interface Article {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 1,
    slug: 'how-to-build-website-in-5-minutes',
    title: '如何5分钟快速搭建一个专业网站',
    excerpt: '不需要任何编程基础，按照本文的步骤操作，你也能在短短5分钟内拥有一个专业级别的网站。',
    content: `<p>在数字化时代，拥有一个专业的网站对于个人品牌和企业发展至关重要。然而，很多人因为缺乏编程知识而对建站望而却步。现在，有了在线建站平台，一切都变得简单起来。</p>
<h2>第一步：选择适合的模板</h2>
<p>登录平台后，你会看到海量的精美模板。根据你的需求类型进行筛选 —— 企业官网、电商店铺、个人博客、作品集等。选择一个与你理想设计最接近的模板作为起点。</p>
<p>不要担心模板和最终效果有差距，平台提供了强大的自定义功能，你可以自由调整颜色、字体、布局等所有元素。</p>
<h2>第二步：自定义页面内容</h2>
<p>使用拖拽式编辑器，你可以轻松地修改页面上的文字、图片和布局。只需要点击你想修改的元素，就可以直接编辑内容。上传你自己的图片，替换模板中的示例内容。</p>
<p>平台内置了丰富的设计元素库，包括按钮、表单、图标、视频播放器等，拖拽即可添加到页面中。</p>
<h2>第三步：设置域名并发布</h2>
<p>完成设计后，你可以绑定自己的自定义域名，或者使用平台提供的免费子域名。确认所有页面无误后，点击发布按钮，你的网站就正式上线了！</p>
<p>整个过程通常只需要5-10分钟，即使是完全没有建站经验的新手也能轻松完成。</p>
<h2>常见问题</h2>
<p><strong>Q: 我需要会写代码吗？</strong><br>A: 完全不需要！平台采用可视化编辑器，所有操作都是拖拽和点击完成的。</p>
<p><strong>Q: 网站能在手机上正常显示吗？</strong><br>A: 所有模板都经过响应式优化，会自动适配手机、平板和电脑屏幕。</p>
<p><strong>Q: 可以绑定我自己的域名吗？</strong><br>A: 当然可以！平台支持绑定任何你购买的域名。</p>`,
    category: '建站教程',
    categorySlug: 'tutorial',
    author: '建站小助手',
    date: '2026-08-08',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20website%20builder%20interface%20with%20drag%20and%20drop%20editor%2C%20warm%20workspace%20environment%2C%20clean%20minimal%20setup%2C%20soft%20natural%20lighting%2C%20professional%20creative%20atmosphere&width=1200&height=630&seq=article-build-01&orientation=landscape',
    tags: ['建站教程', '新手入门', '网站搭建'],
  },
  {
    id: 2,
    slug: 'choose-right-website-template',
    title: '如何选择最适合你的网站模板：专业指南',
    excerpt: '面对海量模板无从下手？本文从行业、功能和设计风格三个维度帮你做出最佳选择。',
    content: `<p>选择合适的网站模板是建站过程中最关键的一步。一个好的模板不仅能节省大量设计时间，还能让你的网站看起来专业且与众不同。</p>
<h2>根据行业选择</h2>
<p>不同的行业有不同的网站需求。比如：</p>
<ul>
<li><strong>企业官网：</strong>需要展示公司介绍、服务内容、团队和联系方式，选择简洁大气的商务模板</li>
<li><strong>电商网站：</strong>需要商品展示、购物车和支付功能，选择功能完善的电商模板</li>
<li><strong>个人博客：</strong>需要文章列表、分类标签和评论区，选择注重阅读体验的模板</li>
<li><strong>餐饮网站：</strong>需要菜单展示、在线预约和地图导航，选择温暖诱人的餐饮模板</li>
</ul>
<h2>关注功能需求</h2>
<p>在选择模板时，务必检查模板是否包含你需要的功能模块。例如，如果你需要收集用户信息，模板中就要有表单组件；如果需要展示大量图片，模板应该支持画廊或瀑布流布局。</p>
<h2>设计风格匹配</h2>
<p>模板的设计风格应该与你的品牌调性一致。如果你的品牌偏向年轻活力，可以选择色彩鲜艳、设计大胆的模板；如果偏向专业稳重，则选择简洁大方、色调内敛的模板。</p>`,
    category: '建站教程',
    categorySlug: 'tutorial',
    author: '设计师小王',
    date: '2026-08-05',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20website%20template%20designs%20displayed%20on%20screen%20with%20warm%20creative%20workspace%2C%20various%20layout%20options%2C%20soft%20ambient%20lighting%2C%20designer%20desk%20setup%2C%20professional%20atmosphere&width=1200&height=630&seq=article-tpl-02&orientation=landscape',
    tags: ['模板选择', '设计指南', '网站搭建'],
  },
  {
    id: 3,
    slug: 'website-seo-optimization-guide',
    title: '网站SEO优化完全指南：从零到排名靠前',
    excerpt: '想让你的网站在搜索引擎中获得更好的排名？这份SEO优化指南涵盖关键词、内容、技术三个层面。',
    content: `<p>SEO（搜索引擎优化）是让你的网站获得免费流量的最有效方式。一个好的SEO策略可以让你的网站在Google等搜索引擎中排名靠前。</p>
<h2>关键词研究</h2>
<p>关键词是SEO的基础。在创建网站内容之前，先要确定目标用户会搜索哪些词汇。使用关键词研究工具，找到搜索量大但竞争度适中的关键词，并将它们自然地融入你的页面标题、描述和内容中。</p>
<h2>内容为王</h2>
<p>搜索引擎喜欢高质量、原创且有价值的内容。定期更新你的网站内容，确保每篇文章都能真正解决用户的问题。内容长度也很重要，通常来说，1500字以上的深度内容比短文更容易获得好的排名。</p>
<h2>技术优化</h2>
<p>确保你的网站加载速度快、移动端友好、有SSL证书。使用语义化的HTML标签（H1-H6），添加alt属性到图片，设置规范的URL结构。这些技术细节对SEO排名有很大影响。</p>
<h2>外部链接建设</h2>
<p>获取其他高质量网站的链接指向你的网站，这是提升域名权重的重要方式。可以通过撰写客座文章、与同行合作、创建有价值的内容等方式获取外部链接。</p>`,
    category: 'SEO优化',
    categorySlug: 'seo',
    author: 'SEO专家老李',
    date: '2026-08-01',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Search%20engine%20optimization%20analytics%20dashboard%20on%20laptop%20screen%2C%20warm%20modern%20office%20setting%2C%20data%20visualization%20charts%2C%20soft%20natural%20lighting%2C%20professional%20digital%20marketing%20workspace&width=1200&height=630&seq=article-seo-03&orientation=landscape',
    tags: ['SEO优化', '搜索引擎', '网站推广'],
  },
  {
    id: 4,
    slug: 'mobile-responsive-design-importance',
    title: '为什么响应式设计对你的网站至关重要',
    excerpt: '超过60%的网站流量来自移动设备，如果你的网站在手机上体验不好，你将失去大部分潜在客户。',
    content: `<p>随着智能手机的普及，越来越多的用户通过手机浏览网站。如果你的网站没有做移动端适配，不仅用户体验差，还会被搜索引擎降权。</p>
<h2>移动流量占比持续增长</h2>
<p>根据最新数据，全球超过60%的网站流量来自移动设备。在某些行业（如餐饮、本地服务），移动端流量占比甚至超过80%。如果你的网站在手机上显示不正常，你将直接失去这些潜在客户。</p>
<h2>Google移动优先索引</h2>
<p>自2019年起，Google已全面采用移动优先索引策略。这意味着Google主要使用你网站的移动版本来进行排名评估。如果你的网站没有移动端适配，在搜索引擎中的排名将受到严重影响。</p>
<h2>如何确保响应式设计</h2>
<p>使用在线建站平台搭建网站时，所有模板都已经过响应式优化，你不需要额外处理。但如果你自己设计，需要注意使用弹性布局、响应式图片和合理的字体大小。</p>`,
    category: '网站设计',
    categorySlug: 'design',
    author: '前端工程师阿杰',
    date: '2026-07-28',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20and%20laptop%20displaying%20same%20responsive%20website%20design%20side%20by%20side%2C%20warm%20minimal%20workspace%2C%20clean%20comparison%20layout%2C%20soft%20natural%20light%2C%20professional%20design%20setup&width=1200&height=630&seq=article-mobile-04&orientation=landscape',
    tags: ['响应式设计', '移动端优化', '用户体验'],
  },
  {
    id: 5,
    slug: 'small-business-website-benefits',
    title: '中小企业为什么一定要有自己的网站',
    excerpt: '在互联网时代，没有网站的中小企业就像没有门面的店铺。一个专业的网站能为你带来什么价值？',
    content: `<p>很多中小企业主认为，有了社交媒体账号就足够了，不需要专门建一个网站。这种想法其实大错特错。</p>
<h2>建立品牌可信度</h2>
<p>当一个潜在客户搜索你的公司时，拥有一个专业的网站能让你的企业看起来更加正规和可信。研究表明，75%的用户会根据网站设计来判断一家公司的可信度。</p>
<h2>24小时全天候营业</h2>
<p>网站就像一个永不关门的店铺。即使在你休息的时候，潜在客户也可以通过网站了解你的产品和服务，甚至直接下单购买。</p>
<h2>低成本高效营销</h2>
<p>相比传统的广告方式，拥有一个SEO优化良好的网站能以更低的成本获取精准客户。通过内容营销，你可以持续吸引对你产品感兴趣的用户。</p>
<h2>掌握客户数据</h2>
<p>通过网站分析工具，你可以了解访客的来源、行为和偏好，从而更好地优化你的产品和服务。</p>`,
    category: '商业洞察',
    categorySlug: 'business',
    author: '商业顾问陈老师',
    date: '2026-07-20',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Small%20business%20owner%20working%20on%20website%20with%20laptop%20in%20warm%20cozy%20cafe%20setting%2C%20professional%20casual%20atmosphere%2C%20soft%20ambient%20lighting%2C%20entrepreneur%20lifestyle%20photography&width=1200&height=630&seq=article-biz-05&orientation=landscape',
    tags: ['中小企业', '商业价值', '数字化转型'],
  },
  {
    id: 6,
    slug: 'ecommerce-website-building-steps',
    title: '从零搭建电商网站：完整步骤拆解',
    excerpt: '想开网店但不知道从何下手？这篇指南带你从选品到上线，一步步搭建你的在线商城。',
    content: `<p>开设在线商城不再是技术难题。使用在线建站平台，一个人就能完成从搭建到运营的全部工作。</p>
<h2>第一步：确定商业模式</h2>
<p>在动手之前，先明确你要销售什么产品、目标客户是谁、定价策略如何。清晰的商业规划是成功的基础。</p>
<h2>第二步：选择电商模板</h2>
<p>在平台中选择一个专为电商设计的模板，确保包含商品列表、商品详情、购物车和结算页面等核心功能。</p>
<h2>第三步：上传商品</h2>
<p>为每个商品拍摄或准备高质量的图片，撰写吸引人的商品描述，设置合理的价格和库存。商品的展示效果直接影响转化率。</p>
<h2>第四步：配置支付方式</h2>
<p>设置在线支付方式，支持信用卡、支付宝、微信支付等多种支付渠道，方便客户完成购买。</p>
<h2>第五步：测试和发布</h2>
<p>在正式发布前，仔细测试每个环节 —— 从浏览商品到完成支付的完整流程，确保一切顺畅无阻。</p>`,
    category: '电商运营',
    categorySlug: 'ecommerce',
    author: '电商达人小林',
    date: '2026-07-15',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Ecommerce%20website%20dashboard%20displayed%20on%20large%20monitor%20with%20product%20management%20interface%2C%20warm%20modern%20office%2C%20order%20analytics%20charts%2C%20soft%20natural%20light%2C%20professional%20setup&width=1200&height=630&seq=article-ecom-06&orientation=landscape',
    tags: ['电商建站', '在线商城', '网店教程'],
  },
];

export const articleCategories = [
  { name: '全部', slug: 'all' },
  { name: '建站教程', slug: 'tutorial' },
  { name: 'SEO优化', slug: 'seo' },
  { name: '网站设计', slug: 'design' },
  { name: '商业洞察', slug: 'business' },
  { name: '电商运营', slug: 'ecommerce' },
];